export const state = {
  schools: []
}
